import React from "react";
import {PageLayout} from "../components/page-layout";
import {LoginButton} from "../components/buttons/login-button";
import {LogoutButton} from "../components/buttons/logout-button";
import {useAuth0} from "@auth0/auth0-react";

export const PagePublic = () => {
    const {isAuthenticated} = useAuth0();

    return (
        <PageLayout>
            <div className="content-layout">
                <div className="content__body">
                    {!isAuthenticated && (
                        <>
                            <LoginButton/>
                        </>
                    )}
                    {isAuthenticated && (
                        <>
                            <LogoutButton/>
                        </>
                    )}
                </div>
            </div>
        </PageLayout>
    );
};
